export default __webpack_public_path__ + "static/media/15.63b09910.png";